var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZ15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78.006 78.368",
    width: 78.006,
    height: 78.368,
    enableBackground: "new 0 0 78.006 78.368",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.75,0c15.828,0,31.39,0,47.426,0c0,5.297,0.803,10.714-0.277,15.725 c-0.744,3.45-1.856,7.404-3.896,10.314c-1.543,2.201-1.665,5.831-5.115,6.594c0.874,3.89-4.641,4.611-4.192,8.41 c0.069,0.584-1.197,1.302-1.803,1.994c-2.5,2.856-3.599,6.902-7.373,8.678c-0.352,5.06-5.126,6.622-7.776,9.866 c-0.147,0.18,0.011,0.61,0.046,1.29c3.563,0,7.124,0,10.686,0c4.872,0,9.749,0.116,14.615-0.058 c1.922-0.069,4.437,1.245,5.633-1.676c0.092-0.225,0.985-0.164,1.506-0.165c5.506-0.01,11.012-0.006,16.777-0.006 c0,4.995,0,9.902,0,14.648c-6.316,4.117-13.409,2.378-20.214,2.451c-18.005,0.191-36.013,0.065-54.019,0.065 c-1.138,0-2.276,0-3.731,0c0-6.079-0.153-11.878,0.13-17.655c0.056-1.142,1.585-2.756,2.787-3.201 c4.307-1.595,6.963-4.403,8.683-8.664c0.766-1.898,3.105-3.108,4.49-4.824c1.754-2.172,4.895-3.155,5.113-6.776 c0.072-1.192,2.516-2.095,3.492-3.414c1.507-2.035,2.692-4.31,3.999-6.492c1.852-3.091,4.852-5.431,5.814-9.159 c0.136-0.528,1.995-0.612,3.056-0.902c-0.482-0.594-0.965-1.188-1.447-1.781c-8.097,0-16.194,0-24.409,0 C11.75,9.978,11.75,5,11.75,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ15);
export default __webpack_public_path__ + "static/media/z15.f049e2e913174e1e8b9234e3c67416ff.svg";
export { ForwardRef as ReactComponent };